import React from "react";
import { X } from "lucide-react";

export default function WelcomeModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="ka-modal-backdrop fade-in" onClick={onClose}>
      <div className="ka-modal" onClick={(e) => e.stopPropagation()}>
        <button
          aria-label="Close"
          onClick={onClose}
          className="absolute top-3 right-3 w-9 h-9 rounded-full flex items-center justify-center text-white hover:bg-white/10 transition"
        >
          <X size={20} />
        </button>
        <div className="aspect-[4/5] sm:aspect-auto sm:h-auto">
          <img
            src="https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=600&q=80"
            alt="Welcome"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-8 sm:p-10 flex flex-col justify-center">
          <h2 className="font-serif text-4xl mb-4">Welcome!</h2>
          <p className="text-white/85 leading-relaxed text-[15px] mb-6">
            Hello and thank you for dropping by our website. We at Keto Ambrosia
            are happy to be of service to you.
          </p>
          <button className="btn-white self-start" onClick={onClose}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
